import { addDays, weekdayOf } from '@sitzmark/core';

/** The days a month's grid shows: whole weeks, Sunday first, from the week holding the 1st. */
export function monthGrid(anyDay: string): string[][] {
  const first = `${anyDay.slice(0, 7)}-01`;
  const start = addDays(first, -weekdayOf(first));
  const weeks: string[][] = [];
  for (let week = 0; week < 6; week += 1) {
    const days = Array.from({ length: 7 }, (_, index) => addDays(start, week * 7 + index));
    // A week wholly in the next month is not drawn.
    if (week > 0 && days[0]!.slice(0, 7) !== first.slice(0, 7)) break;
    weeks.push(days);
  }
  return weeks;
}
